import Handlebars from 'handlebars';

Handlebars.registerHelper('toSTRING', function(obj) {
    return JSON.stringify(obj);
});

Handlebars.registerHelper('or', function(a, b, c) {
    return (a || b || c);
});

Handlebars.registerHelper('minus', function(a, b) {
    return (a - b);
});

Handlebars.registerHelper('plus', function(a, b) {
    return (a - b);
});

Handlebars.registerHelper('gt', function(a, b) {
    return (a > b);
});

Handlebars.registerHelper('lt', function(a, b) {
    return (a < b);
});

Handlebars.registerHelper('eq', function(a, b) {
    return (a == b);
});

Handlebars.registerHelper('ne', function(a, b) {
    return (a !== b);
});

Handlebars.registerHelper('aw', function(a, b) {
    if((a !== null && a !== '' && a !== undefined) && (b !== null && b !== '' && b !== undefined))
        return true;
    else
        return false;
});

Handlebars.registerHelper('repeat', function(n, block) {
    let accum = '';
    for (let i = 1; i <= n; ++i) {
        accum += block.fn(i);
    }
    return accum;
});

Handlebars.registerHelper('times', function(n, block) {
    let accum = '';
    for(let i = 0; i < n; ++i)
        accum += block.fn(i);
    return accum;
});

Handlebars.registerHelper('for', function(from, to, incr, block) {
    let accum = '';
    for(let i = from; i <= to; i += incr)
        accum += block.fn(i);
    return accum;
});

Handlebars.registerHelper('json', function(context) {
    return JSON.stringify(context);
});



// WEBPACK FOOTER //
// ../helpers/obj.js